import AlertWrapperWithoutSuir from './AlertWrapperWithoutSuir';

const AlertWrapper = () => <AlertWrapperWithoutSuir />;

export default AlertWrapper;
